let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6HlRM")).then(() => parcelRequire('eIoxH'));